// Fire-and-forget crash reporting to the backend (dedupes repeats within 60s).
// Uses plain fetch (not axios) to avoid interceptor/import cycles.
const recent = new Map();

// Benign browser noise — transient during deploys / SW lifecycle, self-recovers.
const NOISE = /Failed to update a ServiceWorker|The object is in an invalid state|newestWorker is null|ResizeObserver loop|sw\.js load failed|Cannot update a null\/nonexistent service worker|no longer, usable|not, or is no longer|Registration failed|AbortError/i;

export function reportClientError(payload) {
  try {
    const msg = String(payload.message || "").slice(0, 500);
    if (!msg || NOISE.test(msg)) return;
    const key = msg.slice(0, 120);
    const now = Date.now();
    if (recent.get(key) && now - recent.get(key) < 60000) return;
    recent.set(key, now);
    let user = null;
    try { user = JSON.parse(localStorage.getItem("cached_auth_user") || "null"); } catch {}
    const body = {
      message: msg,
      stack: String(payload.stack || "").slice(0, 3500),
      component_stack: String(payload.componentStack || "").slice(0, 2000),
      label: String(payload.label || "").slice(0, 80),
      source: String(payload.source || "").slice(0, 40),
      page: window.location.pathname.slice(0, 200),
      app_version: (localStorage.getItem("sellox_force_ver") || "").slice(0, 30),
      tenant_id: String(user?.tenant_id || "").slice(0, 80),
      username: String(user?.username || "").slice(0, 80),
      ua: navigator.userAgent.slice(0, 250),
    };
    const base = process.env.REACT_APP_BACKEND_URL || "";
    fetch(`${base}/api/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {});
  } catch {}
}

// True for errors caused by stale/mixed build files after a deploy — a reload fixes them.
export function isStaleBuildError(msg) {
  return /before initialization|Loading chunk|ChunkLoadError|Loading CSS chunk|Unexpected token '</i.test(String(msg || ""));
}

// Reload once (20s guard) so cashiers self-heal instead of seeing a crash screen.
export function reloadOnceForStaleBuild(msg) {
  if (!isStaleBuildError(msg)) return false;
  try {
    const k = "stale_build_reload_ts";
    const last = +(sessionStorage.getItem(k) || 0);
    if (Date.now() - last > 20000) {
      sessionStorage.setItem(k, String(Date.now()));
      window.location.reload();
      return true;
    }
  } catch {}
  return false;
}
